<template>
    <button @click="openLink" type="button" class="btn btn-primary">
        External Link <i class="fas fa-external-link-alt"></i>
    </button>
</template>

<script>
export default {
    name: "ExternalLink",
    props: {
        link: {
            type: String,
            required: true,
            default: "https://ferienwohnungen-tessin.ch"
        }
    },
    methods: {
        openLink: function() {
            window.open(this.link, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
.btn {
    border-radius: $button-border-radius;
    padding: 8px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: 20px;
}
</style>